import React, { useEffect, useRef } from 'react';
import { useTheme } from '../theming/default_theme';
import { get } from '../api/apiService';
import refer from '../assets/icons/referral-not-found.png';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Greeting from '../Pages/Greeting';
import { apiEndPoints } from '../api/apiEndPoints';
import StatusBadge from '../Pages/StatusBadge';
import { convertDateFormat } from '../utils/dateUtils';

interface Patient {
  phone: string;
}
interface ReferralData {
  id: string;
  status: 'INPROGRESS' | 'REFERRED' | 'COMPLETED' | 'DELIVERED';
  patientId: string;
  hospitalId: string;
  ambassadorId: string;
  patientName: string;
  age: string;
  gender: string;
  hospitalName: string;
  city: string;
  state: string;
  createdAt: string;
  patient: Patient;
}

const Referrals: React.FC<{ showModal: boolean, setShowModal: (value: boolean) => void, menuSelected: string }> = ({ showModal, setShowModal, menuSelected }) => {

  const theme = useTheme();
  const navigate = useNavigate();
  const [referralList, setReferralList] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [pageCountIndex, setPageCountIndex] = React.useState(0);
  const [countPerPage, setCountPerPage] = React.useState(5);
  const [searchText, setSearchText] = React.useState('');
  const tableRef = useRef<HTMLTableElement | null>(null);
  const [urlRequestParameters, seturlRequestParameters] = React.useState<string>('');
  const [isFilterApplyClicked, setIsFilterApplyClicked] = React.useState(false);
  const [totalPages, setTotalPages] = React.useState(0);

  useEffect(() => {
    let urlRequestParameters = `?page=${pageCount + pageCountIndex - 1}&size=${countPerPage}&searchString=${searchText.trim()}`;
    urlRequestParameters += `&createdAt,id,desc`;
    seturlRequestParameters(urlRequestParameters);
  }, [showModal, pageCount, pageCountIndex, countPerPage, isFilterApplyClicked, searchText]);

  // Fetch data whenever requestString changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const url = `${apiEndPoints.referralsFilterEndPoint}?page=${pageCount + pageCountIndex - 1}&size=${countPerPage}&searchString=${searchText.trim()}&sort=createdAt,id,desc`;
        console.log('API URL:', url);
        const response = await get(url);
        console.log('API Response:', response);
        const typedResponse = response as { content: any[]; totalPages: number };
        setReferralList(typedResponse.content || []);
        setTotalPages(response.totalPages || 0);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, [pageCount, pageCountIndex, countPerPage, searchText]);

  useEffect(() => {
    setPageCount(1);
    setPageCountIndex(0);
  }, [searchText]);

  const handleSearchTextChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = event.target.value;
    console.log('Search Text:', searchText);
    setSearchText(event.target.value);
    setPageCount(1);
    setPageCountIndex(0);
  }

  const handlePageChange = async (event: React.MouseEvent<HTMLDivElement>) => {
    const page = event.currentTarget.innerText;
    console.log('page:', page);
    console.log('page.includesnext --:', page.includes('Next'));
    console.log('pageCount:', pageCount);
    console.log('pageCountIndex:', pageCountIndex);
    if (page.includes('Prev')) {
      if (pageCount === 1 && pageCountIndex === 0) {
        setPageCount(1);
        setPageCountIndex(0);
      }
      else {
        if ((pageCount % 5 === 1) && (pageCountIndex === 0)) {
          setPageCountIndex(4);
          setPageCount((prevPageCount) => prevPageCount - 5);
        }
        else {
          setPageCountIndex((prevPageCountIndex) => prevPageCountIndex - 1);
        }

      }

      console.log('pageCount:', pageCount);
      console.log('pageCountIndex:', pageCountIndex);
    }

    else if (page.includes('Next')) {
      console.log('you are in next')
      console.log('pageCount+pageCountIndex)%5==0:--', ((pageCount + pageCountIndex) % 5));
      if ((pageCount % 5 === 1) && (pageCountIndex === 4)) {
        setPageCountIndex(0);
        setPageCount((prevPageCount) => prevPageCount + 5);
      }
      else {
        setPageCountIndex((prevPageCountIndex) => prevPageCountIndex + 1);
      }
      console.log('pageCount:', pageCount);
      console.log('pageCountIndex:', pageCountIndex);
    }
    else {
      let pageIndex = (+page.trim()) - 1;   // Convert to number
      console.log('pageIndex:', pageIndex);
      setPageCountIndex(pageIndex % 5);
      setPageCount(Math.floor(pageIndex / 5) * 5 + 1);
      console.log('pageCount:', pageCount);
      console.log('pageCountIndex:', pageCountIndex);
    }

  }

  const exportTableToExcel = () => {
    const tableElement = tableRef.current;

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.table_to_sheet(tableElement);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Referral List');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(dataBlob, 'referral_list.xlsx');
  }

  function onPatientSelect(referral: ReferralData): void {
    navigate(`/referrals/${referral.id}`, { state: { referral } });
  }

  return (
    <div className="overflow-hidden flex flex-col h-full w-full border border-2 mt-2" style={{ backgroundColor: theme.colors.background }}>
      <Greeting />
      <div className="flex flex-row items-center pb-5">
        <div className="flex  flex-row justify-start font-semi bold items-center ml-[24px] mr-[20%]">Referrals</div>
        <input type="text" placeholder="Name, Hospital, City" className={`flex flex-row justify-end h-10 w-[50%] border border-[${theme.borders.color}] rounded-full text-black pl-[10px] mr-10 placeholder:text-sm`} onChange={handleSearchTextChange} />
        <div className="flex items-center justify-center w-12 h-12 rounded-lg cursor-pointer transition flex-shrink-0" onClick={referralList.length > 0 ? exportTableToExcel : undefined}>
          <img src="/download.png" alt="download" className="w-12 h-12" />
        </div>
      </div>

      {/* <div className="flex flex-col w-full px-4 sm:px-6 flex-1 min-h-0">
        {referralList.length === 0 ? (
          <div className="w-full h-full flex justify-center items-center">
            <img
              src={refer}
              alt="referral"
              className="max-w-full h-auto"
              style={{
                maxHeight: '400px',
                objectFit: 'contain'
              }}
            />
          </div>
        ) : (
          <div className="flex flex-col h-full">
            <div
              className="flex-1 border rounded-xl overflow-hidden"
              style={{
                backgroundColor: theme.colors.secondary,
                borderColor: theme.borders.greyBorder,
                minHeight: '300px'
              }}
            >
              <div className="w-full h-full overflow-auto">
                <table
                  ref={tableRef}
                  className="w-full text-start"
                  style={{
                    minWidth: '800px',
                    borderRadius: "8px",
                    fontFamily: theme.typography.fontFamily,
                    fontWeight: theme.typography.fontWeightBold,
                    fontSize: theme.typography.fontSize,
                    color: theme.colors.text,
                    background: "inherit"
                  }}
                >
                  <thead className={`sticky top-0 w-full font-bold bg-[${theme.colors.surfaceCard}]`} style={{ borderBottomColor: theme.borders.color }}>
                    <tr>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Referrals</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Age & Gender</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden sm:table-cell">Guardian Contact</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Referred Hospital</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden md:table-cell">City & State</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden lg:table-cell">Referred On</th>
                      <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Treatment Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {(referralList && referralList.map((referral, index) => (
                      <tr key={referral.id}
                        className="hover:bg-gray-50 cursor-pointer"
                        onClick={() => onPatientSelect(referral)}>
                        <td className="px-3 sm:px-6 py-4 text-gray-900 hover:text-gray-600">{referral.patientName}</td>
                        <td className="px-3 sm:px-6 py-4 text-gray-800">{referral.age}, {referral.gender}</td>
                        <td className="px-3 sm:px-6 py-4 text-gray-900 hidden sm:table-cell">{referral.patient.phone}</td>
                        <td className="px-3 sm:px-6 py-4 text-gray-800">{referral.hospitalName}</td>
                        <td className="px-3 sm:px-6 py-4 text-gray-800 hidden md:table-cell">{`${referral.city}, ${referral.state}`}</td>
                        <td className="px-3 sm:px-6 py-4 text-gray-800 hidden lg:table-cell">{convertDateFormat(referral.createdAt)}</td>
                        <td className="px-2 sm:px-4 py-2 items-center justify-center">
                          {referral.status === 'COMPLETED' || referral.status === 'DELIVERED' ? (
                            <StatusBadge backgroundColor="#E8F6EE" textColor="#27AE60" text="Delivered" />
                          ) : referral.status === 'REFERRED' ? (
                            <StatusBadge backgroundColor="#DBEAFE" textColor="#1D4ED8" text="Referred" />
                          ) : referral.status === 'INPROGRESS' ? (
                            <StatusBadge backgroundColor="#DBEAFE" textColor="#1D4ED8" text="In Progress" />
                          ) : (
                            <StatusBadge backgroundColor="#EEEEEE" textColor="#757575" text="Unknown" />
                          )}
                        </td>
                      </tr>
                    )))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center mt-4 gap-2 py-4">
              <div
                className={`${(pageCount + pageCountIndex - 1) !== 0 ? 'flex items-center cursor-pointer px-3 py-2 rounded hover:bg-gray-100' : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed px-3 py-2 rounded'}`}
                onClick={(e) => handlePageChange(e)}
              >
                <span className="hidden sm:inline">&laquo;Prev</span>
                <span className="sm:hidden">&laquo;</span>
              </div>
              <div className="flex items-center gap-1">
                {[0, 1, 2, 3, 4].map((offset) => {
                  const pageNumber = pageCount + offset;
                  const isCurrentPage = offset === pageCountIndex;
                  const isValidPage = pageNumber <= totalPages;

                  if (!isValidPage) return null;

                  return (
                    <div
                      key={offset}
                      className={`${isValidPage
                          ? isCurrentPage
                            ? 'flex items-center cursor-pointer px-3 py-2 rounded bg-[#102A83] text-white'
                            : 'flex items-center cursor-pointer px-3 py-2 rounded hover:bg-gray-100'
                          : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed px-3 py-2 rounded'
                        }`}
                      onClick={handlePageChange}
                    >
                      {pageNumber}
                    </div>
                  );
                })}
              </div>
              <div
                className={`${(pageCount + 5 <= totalPages) ? 'flex items-center cursor-pointer px-3 py-2 rounded hover:bg-gray-100' : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed px-3 py-2 rounded'}`}
                onClick={handlePageChange}
              >
                <span className="hidden sm:inline">Next&raquo;</span>
                <span className="sm:hidden">&raquo;</span>
              </div>
            </div>
          </div>
        )}
      </div> */}
      <div className={`flex  justify-start items-center ml-[24px]  w-[96%] h-full overflow-hidden`}>
        {(((pageCount + pageCountIndex) != 1) || (referralList && referralList.length > 0)) ? (
          <div className="flex flex-col w-full h-full">
            <div
              className={`flex justify-center items-center w-full h-[78%] border border-2 border-[${theme.borders.greyBorder}] rounded-[16px]`}
              style={{
                // overflowY: 'scroll',
                overflowX: 'hidden',
                borderRadius: 16,
                background: 'inherit',
                // boxSizing: 'content-box',
                backgroundColor: theme.colors.secondary,
                justifyItems: "start",
                alignItems: "start"
              }}
            >
              <table ref={tableRef} className="table-fixed h-full text-start border border-1" style={{ width: "100%", height: "100%", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text, borderRadius: 16, background: 'inherit' }}>
                <thead className="w-full sticky top-0 font-bold bg-[#F9F7ED] border border-1">
                  <tr>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Referrals</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Age & Gender</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden sm:table-cell">Guardian Contact</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Referred Hospital</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden md:table-cell">City & State</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left hidden lg:table-cell">Referred On</th>
                    <th scope="col" className="px-3 sm:px-6 py-4 font-semibold text-left">Treatment Status</th>
                  </tr>
                </thead>
                <tbody
                  className={`w-full text-start border border-[${theme.borders.color}] align-top`}
                  style={{ borderBottomColor: theme.borders.color, verticalAlign: 'top' }}
                >
                  {(referralList && referralList.map((referral, index) => (
                    <tr key={referral.id}
                      className="hover:bg-gray-50 cursor-pointer border border-1"
                      onClick={() => onPatientSelect(referral)}>
                      <td className="px-3 sm:px-6 py-4 text-gray-900 hover:text-gray-600">{referral.patientName}</td>
                      <td className="px-3 sm:px-6 py-4 text-gray-800">{referral.age}, {referral.gender}</td>
                      <td className="px-3 sm:px-6 py-4 text-gray-900 hidden sm:table-cell">{referral.patient?.phone}</td>
                      <td className="px-3 sm:px-6 py-4 text-gray-800">{referral.hospitalName}</td>
                      <td className="px-3 sm:px-6 py-4 text-gray-800 hidden md:table-cell">{`${referral.city}, ${referral.state}`}</td>
                      <td className="px-3 sm:px-6 py-4 text-gray-800 hidden lg:table-cell">{convertDateFormat(referral.createdAt)}</td>
                      <td className="px-2 sm:px-4 py-2 items-center justify-center">
                        {referral.status === 'COMPLETED' || referral.status === 'DELIVERED' ? (
                          <StatusBadge backgroundColor="#E8F6EE" textColor="#27AE60" text="Delivered" />
                        ) : referral.status === 'REFERRED' ? (
                          <StatusBadge backgroundColor="#DBEAFE" textColor="#1D4ED8" text="Referred" />
                        ) : referral.status === 'INPROGRESS' ? (
                          <StatusBadge backgroundColor="#FFF8DC" textColor="#FFC107" text="In Progress" />
                        ) : (
                          <StatusBadge backgroundColor="#EEEEEE" textColor="#757575" text="Unknown" />
                        )}
                      </td>
                    </tr>
                  )))}
                </tbody>
              </table>

            </div>
            {/* {showFilter && <FilterHospitalSideBar setShowFilter={setShowFilter} showFilter={showFilter} hospitalList={hospitalList} allHospitals={allHospitals} setAllHospitals={setAllHospitals} selectedCities={selectedCities} setSelectedCities={setSelectedCities} selectedServices={selectedServices} setSelectedServices={setSelectedServices} setIsFilterApplyClicked={setIsFilterApplyClicked}/> } */}
            <div className="flex flex-row items-center mt-10 gap-x-10 w-[30%] h-[10%] ml-[30%] justify-between">
              {/* Previous Button */}
              <div
                className={`${(pageCount + pageCountIndex - 1) != 0
                  ? 'flex items-center cursor-pointer'
                  : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'
                  }`}
                onClick={(pageCount + pageCountIndex - 1) != 0 ? handlePageChange : undefined}
              >
                &laquo;Prev
              </div>

              {/* Page Numbers */}
              {[...Array(5)].map((_, i) => {
                const pageNumber = pageCount + i;
                const isActive = i === pageCountIndex;
                const isDisabled = pageNumber > totalPages; // Disable if the page number exceeds total pages
                return (
                  <div
                    key={pageNumber}
                    className={`flex items-center px-4 py-2 ${isActive
                      ? 'bg-[#102A83] text-white rounded-full'
                      : 'text-[#102A83]'
                      } ${isDisabled ? 'pointer-events-none opacity-50 cursor-not-allowed' : 'cursor-pointer'
                      }`}
                    onClick={!isDisabled ? handlePageChange : undefined}
                  >
                    {pageNumber}
                  </div>
                );
              })}

              {/* Next Button */}
              <div
                className={`${(pageCount + 5 <= totalPages)
                  ? 'flex items-center cursor-pointer'
                  : 'flex items-center pointer-events-none opacity-50 cursor-not-allowed'
                  }`}
                onClick={(pageCount + 5 <= totalPages) ? handlePageChange : undefined}
              >
                <span>Next&raquo;</span>
              </div>
            </div>
          </div>

        ) : (
          <div className="flex flex-col justify-center items-center w-full h-full">
            <div className="flex flex-col w-[50%] h-auto justify-center items-center overflow-visible rounded-[16px]">
              <img
                src={refer}
                alt="no referral's found"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default Referrals;
